import React from 'react';
import KimSummaryInfo from '../../blocks/PageInfo/KimGroupIngo/KimSummaryInfo';
import style from './KimGroup.module.scss';

const KimSummary: React.FC = () => (
  <>
    <div className={style.container}>
      <KimSummaryInfo />
    </div>
    <div className={style.frame}>
      <iframe
        width="100%"
        height="100%"
        src="https://pix.tektorg.ru/shared/view/6816245f-5295-4421-ad80-ab5df549b0df"
        title="kim-summary"
      />
    </div>
  </>
);

export default KimSummary;
